import SPopup from './SPopup.vue';
import Vue from 'vue';
import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';

declare class IPopupComponent extends SPopup {
  public id?: number;
  public cancel(id: number): void;
}

const PopupConstructor = Vue.extend(SPopup);

const Popup: IPopup = (message: string | TranslateResult, options = {}) => {
  const propsData: IPopupOptions = {
    message,
    open: true,
    dimmer: true,
    resizable: false,
    movable: false,
    pinnable: false,
    ...options,
    id: Popup.id++,
    onCancel: Popup.cancel.bind(null, Popup.id, options.onCancel),
  };

  const instance = (new PopupConstructor({
    propsData,
    i18n,
  }) as IPopupComponent);

  instance.$on('update:open', (open: boolean) => {
    instance.$props.open = open;
  });

  instance.$mount();
  Popup.instances.push(instance);

  return instance;
};

// eslint-disable-next-line no-array-constructor
Popup.instances = [];
Popup.id = 0;

Popup.confirm = (message, options) => {
  options = {
    onConfirm: () => null,
    ...options,
  };
  return Popup(message, options);
};

Popup.alert = (message, options) => {
  const { ...newOptions } = { ...options };
  return Popup(message, newOptions);
};

Popup.cancel = (id, callback) => {
  Popup.instances = Popup.instances.filter(inst => inst.id !== id);
  if (callback) callback();
};

export default Popup;

export interface IPopupButton {
  text: string | TranslateResult;
  color?: string;
  click: Function;
  disabled?: boolean;
  isLoading?: boolean;
  icon?: string;
}

interface IPopupOptions {
  id?: number;
  title?: string | TranslateResult;
  message?: string | TranslateResult;
  confirmText?: string | TranslateResult;
  closeText?: string | TranslateResult;
  open?: boolean;
  dimmer?: boolean;
  resizable?: boolean;
  movable?: boolean;
  pinnable?: boolean;
  withCloseButton?: boolean;
  buttons?: IPopupButton[];
  onConfirm?: () => void;
  onCancel?: () => void;
}

export interface IPopup {
  (message: string | TranslateResult, options?: IPopupOptions): IPopupComponent;
  instances: IPopupComponent[];
  id: number;
  confirm(message: string | TranslateResult, options?: IPopupOptions): IPopupComponent;
  alert(message: string | TranslateResult, options?: IPopupOptions): IPopupComponent;
  cancel(id: number, callback?: () => void): void;
}
